import isBefore from 'date-fns/isBefore'
import isSameDay from 'date-fns/isSameDay'

export default {
  inject: ['systemStatus'],

  computed: {
    nextOrderDay() {
      return this.systemStatus ? new Date(this.systemStatus.next_order_day) : new Date()
    },

    orderDayIsValid() {
      return (!isBefore(this.date, this.nextOrderDay) || isSameDay(this.date, this.nextOrderDay))
      //  && !this.isSunday && !this.isExcluded
    },
  }
}
